import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CalendarPage } from './pages/CalendarPage';
import { BookingPage } from './pages/BookingPage';
import { CustomPaymentPage } from './pages/CustomPaymentPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/consultation" element={<CalendarPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/custom-payment" element={<CustomPaymentPage />} />
          <Route path="*" element={<Navigate to="/consultation" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
